module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4a3e75a918bb16870f05d1fff7fdc7d2.gif";